import { defineMessages } from 'react-intl';

export default defineMessages({
    ok: {
        id: 'app.components.SendEmailResult.ok',
        defaultMessage: 'Ok'
    },
    notValidOrDuplicate: {
        id: 'app.components.SendEmailResult.notValidOrDuplicate',
        defaultMessage: 'not valid or duplicate email'
    },
    emailSent: {
        id: 'app.components.SendEmailResult.emailSent',
        defaultMessage: 'email successfully sent'
    },
    emailsSent: {
        id: 'app.components.SendEmailResult.emailsSent',
        defaultMessage: 'emails successfully sent'
    },
    emailNotSent: {
        id: 'app.components.SendEmailResult.emailNotSent',
        defaultMessage: 'email not sent'
    },
    emailsNotSent: {
        id: 'app.components.SendEmailResult.emailsNotSent',
        defaultMessage: 'emails not sent'
    },
    emailAlreadyVerified: {
        id: 'app.components.SendEmailResult.emailAlreadyVerified',
        defaultMessage: 'email address already verified'
    },
    emailsAlreadyVerified: {
        id: 'app.components.SendEmailResult.emailsAlreadyVerified',
        defaultMessage: 'email addresses already verified'
    },
    unableToSend: {
        id: 'app.components.SendEmailResult.unableToSend',
        defaultMessage: 'Unable to send email at this time.'
    },
    tryAgain: {
        id: 'app.components.SendEmailResult.tryAgain',
        defaultMessage: 'Please try again later.'
    },
    sendEmails: {
        id: 'app.components.SendEmailResult.sendEmails',
        defaultMessage: 'Send verification emails'
    }
});



// WEBPACK FOOTER //
// ./app/components/send-email-result/messages.js